/* Drezanielle Atelier — quiet physical interface (motion layer).
   One small module. transform/opacity only. Everything is gated behind
   prefers-reduced-motion: no-preference; reduced users get a static page.
   Principles (apple-design):
   - critically damped feel (no overshoot) via a long ease-out curve
   - feedback on pointer-down (CSS handles :active; here only media settle)
   - no scroll-jacking, no looped animation, no layout shift            */

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reduced) {
  /* Hero media settle: the photograph arrives with a slow physical settle,
     scale 1.03 → 1 with a hint of opacity — critically damped character. */
  const settle = () => {
    const imgs = document.querySelectorAll('.hero__media img, .hero__media video');
    imgs.forEach((img) => {
      if (img.dataset.dzSettled) return;
      img.dataset.dzSettled = '1';
      img.animate(
        [
          { transform: 'scale(1.03)', opacity: 0.85 },
          { transform: 'scale(1)', opacity: 1 },
        ],
        {
          duration: 700,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)', // long ease-out ≈ damping 1.0
          fill: 'backwards',
        }
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', settle, { once: true });
  } else {
    settle();
  }

  /* Shopify view transitions swap pages without full reload — re-arm. */
  document.addEventListener('shopify:section:load', settle);
}
